import { actionGenerator, IReduxAction } from '../../utils/actions';

export const RELOAD_PUBLISH_TERMS_START = 'PUBLISH_TERMS :: RELOAD_START';

export type TReloadPublishTermsStartAction = IReduxAction<typeof RELOAD_PUBLISH_TERMS_START>;

export const reloadPublishTermsStart = actionGenerator<typeof RELOAD_PUBLISH_TERMS_START>(RELOAD_PUBLISH_TERMS_START);
